import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const MinusIconV2 = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 42}
          height={props.height ?? 40}
          viewBox="0 0 42 40"
          fill="none"
          {...props}
        >
          <Rect
            x="0.617188"
            y="0.126953"
            width="41"
            height="39"
            rx="8"
            fill="white"
            fillOpacity="0.85"
          />
          <Path
            d="M9.11719 15.5312H33.1172V23.7241H9.11719V15.5312Z"
            fill={props.color ?? '#E2753A'}
          />
        </Svg>
      </View>
    );
  },
);

export { MinusIconV2 };
